(function () {
  'use strict';

  /* @ngdoc object
   * @name flyingHoursAllowance
   * @description
   *
   */
  angular
    .module('flyingHoursAllowance', [
      'ui.router'
    ]);
}());
